import { render, staticRenderFns } from "./PurchaseOrderComments.vue?vue&type=template&id=48c8193e"
import script from "./PurchaseOrderComments.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c8193e')) {
      api.createRecord('48c8193e', component.options)
    } else {
      api.reload('48c8193e', component.options)
    }
    module.hot.accept("./PurchaseOrderComments.vue?vue&type=template&id=48c8193e", function () {
      api.rerender('48c8193e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PurchaseOrderComments.vue"
export default component.exports